
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./atoms.cjs.production.min.js')
} else {
  module.exports = require('./atoms.cjs.development.js')
}
